var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "auth-layout" }, [
    _c("div", { staticClass: "main va-row" }, [
      _c("div", { staticClass: "auth-content flex lg6 xs12 fill-height" }, [
        _c("div", { staticClass: "flex-center" }, [_c("router-view")], 1),
      ]),
      _c("div", { staticClass: "auth-layout__auth-wallpaper flex md6" }, [
        _c(
          "div",
          { staticClass: "flex-center" },
          [
            _c("div", {
              staticClass: "auth-layout__auth-wallpaper__cross-line",
            }),
            _c(
              "router-link",
              {
                staticClass: "auth-layout__auth-wallpaper__logo",
                attrs: { to: { path: "/" } },
              },
              [_c("vuestic-icon-vuestic")],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }